/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packagePreviewer.vue?vue&type=template&id=46f3c0f0&scoped=true&"
import script from "./packagePreviewer.vue?vue&type=script&lang=js&"
export * from "./packagePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./packagePreviewer.vue?vue&type=style&index=0&id=46f3c0f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3c0f0",
  null
  
)

export default component.exports